import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import RequireAuth from './RequireAuth';
import ScrollToTop from './components/ScrollToTop';

// Layouts
import PublicLayout from './layouts/PublicLayout';
import TeacherLayout from './layouts/TeacherLayout';
import AdminLayout from './layouts/AdminLayout';
import StudentLayout from './layouts/StudentLayout';

// Public Pages
import HomePage from './pages/Public/HomePage';
import AboutPage from './pages/Public/AboutPage';
import RoleSelectionPage from './pages/Public/RoleSelectionPage';
import ProgramPage from './pages/Public/ProgramPage';
import AcademicStaffPage from './pages/Public/AcademicStaffPage';
import NewsPage from './pages/Public/NewsPage';
import Products from './pages/Public/Products';
import OnlineCourses from './pages/Public/OnlineCourses';
import Downloads from './pages/Public/Downloads';
import Partners from './pages/Public/Partners';
import References from './pages/Public/References';
import ResearchDevelopment from './pages/Public/ResearchDevelopment';
import Technology from './pages/Public/Technology';
import PaymentPage from './pages/PaymentPage';

// Auth Pages (Public)
import StudentLoginPage from './pages/Private/Student/StudentLoginPage';
import TeacherLoginPage from './pages/Private/Teacher/TeacherLoginPage';
import AdminLoginPage from './pages/Private/Admin/AdminLoginPage';
import TeacherRegisterPage from './pages/Private/Teacher/TeacherRegisterPage';
import StudentRequestForm from './pages/Private/Student/StudentRequestForm';

// Email Verification Pages
import VerifyEmail from './pages/Public/VerifyEmail';
import ForgotPassword from './pages/Public/ForgotPassword';
import ResetPassword from './pages/Public/ResetPassword';
import ResendVerification from './pages/Public/ResendVerification';
import VerifyStudentEmail from './pages/Public/VerifyStudentEmail';

// Teacher Pages (Mevcut)
import TeacherDashboard from './pages/Private/Teacher/TeacherDashboard';
import CreateCourse from './pages/Private/Teacher/CreateCourse';
import AddStudent from './pages/Private/Teacher/AddStudent';
import AddLesson from './pages/Private/Teacher/AddLesson';
import TeacherCourses from './pages/Private/Teacher/TeacherCourses';
import TeacherLessons from './pages/Private/Teacher/TeacherLessons';
import TeacherSettings from './pages/Private/Teacher/TeacherSettings';

// YENİ Teacher Pages (Kurs Yönetimi)
import CourseModules from './pages/Private/Teacher/CourseManagement/CourseModules';
import ModuleLessons from './pages/Private/Teacher/CourseManagement/ModuleLessons';
import CreateQuiz from './pages/Private/Teacher/QuizManagement/CreateQuiz';
import QuizResults from './pages/Private/Teacher/QuizManagement/QuizResults';
import CreateAssignment from './pages/Private/Teacher/AssignmentManagement/CreateAssignment';
import GradeSubmissions from './pages/Private/Teacher/AssignmentManagement/GradeSubmissions';

// Admin Pages (Mevcut)
import AdminDashboard from './pages/Private/Admin/AdminDashboard';
import AdminStudentRequests from './pages/Private/Admin/AdminStudentRequests';
import AdminStudents from './pages/Private/Admin/AdminStudents';
import AdminCourses from './pages/Private/Admin/AdminCourses';
import AdminTeachers from './pages/Private/Admin/AdminTeachers';
import AdminSettings from './pages/Private/Admin/AdminSettings';

// Student Pages (Mevcut)
import StudentDashboard from './pages/Private/Student/StudentDashboard';
import StudentCourses from './pages/Private/Student/StudentCourses';
import StudentLessons from './pages/Private/Student/StudentLessons';
import StudentCertificates from './pages/Private/Student/StudentCertificates';
import StudentSettings from './pages/Private/Student/StudentSettings';

// YENİ Student Pages
import CourseDetail from './pages/Private/Student/CourseView/CourseDetail';
import LessonView from './pages/Private/Student/CourseView/LessonView';
import TakeQuiz from './pages/Private/Student/QuizView/TakeQuiz';
import QuizResult from './pages/Private/Student/QuizView/QuizResult';
import SubmitAssignment from './pages/Private/Student/AssignmentView/SubmitAssignment';
import ViewFeedback from './pages/Private/Student/AssignmentView/ViewFeedback';

// 404 Page
import NotFoundPage from './pages/Public/NotFoundPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* ==================== PUBLIC ROUTES ==================== */}
          <Route element={<PublicLayout />}>
            {/* Ana Sayfa */}
            <Route path="/" element={<HomePage />} />
            
            {/* Kurumsal Sayfalar */}
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs" element={<ProgramPage />} />
            <Route path="/academic-staff" element={<AcademicStaffPage />} />
            <Route path="/news" element={<NewsPage />} />
            
            {/* Kaynaklar */}
            <Route path="/products" element={<Products />} />
            <Route path="/online-courses" element={<OnlineCourses />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/references" element={<References />} />
            <Route path="/research-development" element={<ResearchDevelopment />} />
            <Route path="/technology" element={<Technology />} />
            
            {/* Giriş ve Kayıt */}
            <Route path="/login" element={<RoleSelectionPage />} />
            <Route path="/student-login" element={<StudentLoginPage />} />
            <Route path="/teacher-login" element={<TeacherLoginPage />} />
            <Route path="/admin-login" element={<AdminLoginPage />} />
            <Route path="/teacher-register" element={<TeacherRegisterPage />} />
            <Route path="/student-request" element={<StudentRequestForm />} />
            
            {/* Email Doğrulama ve Şifre İşlemleri */}
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/resend-verification" element={<ResendVerification />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-student-email/:token" element={<VerifyStudentEmail />} />

            
            {/* Ödeme */}
            <Route path="/payment" element={<PaymentPage />} />
          </Route>

          {/* ==================== STUDENT PANEL ==================== */}
          <Route 
            path="/student/*" 
            element={
              <RequireAuth allowedRoles={['student']}>
                <StudentLayout />
              </RequireAuth>
            }
          >
            <Route index element={<StudentDashboard />} />
            <Route path="courses" element={<StudentCourses />} />
            <Route path="course/:courseId" element={<CourseDetail />} />
            <Route path="lesson/:lessonId" element={<LessonView />} />
            <Route path="quiz/:quizId" element={<TakeQuiz />} />
            <Route path="quiz/:quizId/result" element={<QuizResult />} />
            <Route path="assignment/:assignmentId" element={<SubmitAssignment />} />
            <Route path="assignment/:assignmentId/feedback" element={<ViewFeedback />} />
            <Route path="lessons" element={<StudentLessons />} />
            <Route path="certificates" element={<StudentCertificates />} />
            <Route path="settings" element={<StudentSettings />} />
          </Route>

          {/* ==================== TEACHER PANEL ==================== */}
          <Route 
            path="/teacher/*" 
            element={
              <RequireAuth allowedRoles={['teacher']}>
                <TeacherLayout />
              </RequireAuth>
            }
          >
            <Route index element={<TeacherDashboard />} />
            <Route path="my-courses" element={<TeacherCourses />} />
            <Route path="courses/:courseId/modules" element={<CourseModules />} />
            <Route path="module/:moduleId/lessons" element={<ModuleLessons />} />
            <Route path="lesson/:lessonId/create-quiz" element={<CreateQuiz />} />
            <Route path="quiz/:quizId/results" element={<QuizResults />} />
            <Route path="lesson/:lessonId/create-assignment" element={<CreateAssignment />} />
            <Route path="assignment/:assignmentId/grade" element={<GradeSubmissions />} />
            <Route path="lessons" element={<TeacherLessons />} />
            <Route path="create-course" element={<CreateCourse />} />
            <Route path="add-lesson" element={<AddLesson />} />
            <Route path="add-student" element={<AddStudent />} />
            <Route path="settings" element={<TeacherSettings />} />
          </Route>

          {/* ==================== ADMIN PANEL ==================== */}
          <Route 
            path="/admin/*" 
            element={
              <RequireAuth allowedRoles={['admin']}>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="students" element={<AdminStudents />} />
            <Route path="teachers" element={<AdminTeachers />} />
            <Route path="courses" element={<AdminCourses />} />
            <Route path="student-requests" element={<AdminStudentRequests />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* ==================== 404 NOT FOUND ==================== */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;